import request, { METHODS, shjRequest, sviRequest } from '@/api'
import API from '@/services/typings'
import { trans } from '@/utils/common'
import { get } from 'lodash-es'
import UrlConfig from '@/api/UrlConfigs'
import UrlConfigBudget from '@/api/UrlConfigsBudgetSvi'

/**
 * 云客服
 */
export const queryCallUser = (option?: API.Options) => {
  const { pageId = 1, pageSize = 99999 } = option?.params || {};
  return request(
    // `/clue-web/clueInfo/queryCallUser/${pageId}/${pageSize}`
    UrlConfig.Clue.QueryCallUser + `${pageId}/${pageSize}`,
    {
      method: METHODS.POST,
      data: option?.data,
    }).then(resp => {
      return resp
    })
}
/**
 * 电商专员
 */
export const queryEcommerce = (id: string | number) => {
  return request(
    // `/clue-web/clueInfo/queryEcommerce/1/99999`
    UrlConfig.Clue.QWueryEcommerce + `1/99999`
    , {
      method: METHODS.POST,
      data: { bizOpIdList: [id] },
    }).then(resp => {
      return resp
    })
}

// 线索：编辑
export const updateClue = async (option: API.Options) => {
  return await request(
    // `/clue-web/clueInfo/updateClue`
    UrlConfig.Clue.UpdateClue, { method: METHODS.POST, ...option })
}